export default __webpack_public_path__ + "static/media/about-sec-img.1c639857.png";